export function laudoEmModoTeste(laudo: {
  vistoriadora?: { modoTeste?: boolean } | null;
  parceiro?: { modoTeste?: boolean } | null;
}): boolean {
  return !!laudo.vistoriadora?.modoTeste || !!laudo.parceiro?.modoTeste;
}

/**
 * Uma compra de crédito de um Parceiro deve usar a tela de checkout simulada (em vez
 * do Sandbox Asaas real) quando: o PRÓPRIO Parceiro está em modo teste E a Vistoriadora
 * escolheu 'simulacao'. Isso espelha exatamente a fonte de verdade da RPC
 * ativar_creditos_compra (migrations/split_eixo1_eixo2.sql), que deriva v_modo_teste
 * só do empresas.modo_teste do comprador (Parceiro) — nunca da Vistoriadora.
 * NÃO usar a regra OR de laudoEmModoTeste aqui: isso permitiria simular checkout com
 * um Parceiro que a RPC trata como modo_teste=false, gerando crédito real e uma
 * split_transferencias real (com chave_pix real) a partir de um pagamento falso.
 */
export function deveSimularCompraCredito(params: {
  parceiro?: { modoTeste?: boolean } | null;
  vistoriadora?: { modoTeste?: boolean; modoTesteCreditoMetodo?: string } | null;
}): boolean {
  return (
    !!params.parceiro?.modoTeste &&
    !!params.vistoriadora?.modoTeste &&
    params.vistoriadora?.modoTesteCreditoMetodo === "simulacao"
  );
}

// Self-check: node --import tsx shared/modo-teste.ts
// ponytail: guarded with typeof — este arquivo é importado por ComprarCreditos.tsx e
// AssinarlLaudo.tsx e entra no bundle do browser, onde `process` não existe.
if (typeof process !== "undefined" && process.argv[1]?.endsWith("modo-teste.ts")) {
  console.assert(
    deveSimularCompraCredito({
      parceiro: { modoTeste: true },
      vistoriadora: { modoTeste: true, modoTesteCreditoMetodo: "simulacao" },
    }) === true,
    "parceiro em teste + vistoriadora em simulacao deveria simular",
  );
  console.assert(
    deveSimularCompraCredito({
      parceiro: { modoTeste: false },
      vistoriadora: { modoTeste: true, modoTesteCreditoMetodo: "simulacao" },
    }) === false,
    "BUG COBERTO: parceiro fora de modo teste NÃO deveria simular, mesmo com vistoriadora em modo teste + simulacao",
  );
  console.assert(
    deveSimularCompraCredito({
      parceiro: { modoTeste: true },
      vistoriadora: { modoTeste: true, modoTesteCreditoMetodo: "sandbox_asaas" },
    }) === false,
    "método sandbox_asaas nunca deveria simular",
  );
  console.assert(
    deveSimularCompraCredito({
      parceiro: { modoTeste: true },
      vistoriadora: { modoTeste: false, modoTesteCreditoMetodo: "simulacao" },
    }) === false,
    "BUG COBERTO: vistoriadora com modo teste desligado (método 'simulacao' residual) NÃO deveria simular",
  );
  console.assert(
    deveSimularCompraCredito({
      parceiro: { modoTeste: false },
      vistoriadora: { modoTeste: false, modoTesteCreditoMetodo: "simulacao" },
    }) === false,
    "fora de modo teste nunca deveria simular, mesmo com simulacao configurada",
  );
  console.log("modo-teste.ts self-check OK");
}
